export default "__VITE_ASSET__BvXX2xPI__"